/**
 * requestUrl         接口请求地址
 * ImageUrl           图片地址
 * FileUrl            文件地址
 * */

let comeinUrl, comeinImageUrl, comeinFileUrl, hsUrl;

// 环境区分
// if (/(https|http):\/\/(xxx\.cn)/i.test(location.href.toLowerCase())) {
//     // 生产环境
// 	requestUrl = '';
// } else {
//     // 测试环境
// 	requestUrl = '';
// }
// 线上环境
let requestUrl = 'https://www.vipss.vip/api/';
// let requestUrl = 'https://vipss.oldcow.shop/api/';
// let requestUrl = 'http://127.0.0.1:8081/vipss/';

// weibo share 微博分享地址
export const WB_SHARE = 'http://service.weibo.com/share/share.php';

export const REQUEST_URL = requestUrl;
